import { encryptStorage } from "./EncryptStorage";

export function clearAuthSession() {
  const selectedLanguage = localStorage.getItem("i18nextLng");

  encryptStorage.clear();
  localStorage.clear();

  if (selectedLanguage) {
    localStorage.setItem("i18nextLng", selectedLanguage);
  }
}
